import cssGlobal from '../../../utils/cssGlobal';
import constants from '../../../constants/styles';
import 'primereact/components/common/Common.css';

const { MODALTABS_NAV_BACKGROUND_COLOR, MODALTABS_TAB_COLOR } = constants;

export const styles = {
  modaltabview: { width: '100%' }
};

export default cssGlobal({
  '.ui-tabview, .ui-tabview .ui-tabview-panel': {
    padding: 0
  },
  '.ui-tabview.ui-tabview-top>.ui-tabview-nav': {
    padding: 0,
    background: MODALTABS_NAV_BACKGROUND_COLOR,
    borderRadius: 0,
    marginTop: -1,
    fontSize: '0.9em'
  },
  '.ui-widget-header': {
    border: 0
  },
  '.ui-tabview .ui-tabview-nav > li.ui-state-default': {
    border: 0,
    margin: 0,
    top: 0,
    background: 'none'
  },
  '.ui-tabview .ui-tabview-nav > li.ui-state-default.ui-state-active': {
    borderBottom: '2px solid white'
  },
  '.ui-tabview .ui-tabview-nav > li:not(.ui-state-active):not(.ui-state-disabled):hover': {
    background: 'none',
    color: MODALTABS_TAB_COLOR
  },
  '.ui-tabview .ui-tabview-nav > li:not(.ui-state-active):not(.ui-state-disabled):hover a': {
    color: MODALTABS_TAB_COLOR
  },
  '.ui-state-default a': {
    color: MODALTABS_TAB_COLOR
  },
  '.ui-tabview .ui-tabview-nav li a': {
    paddingLeft: 20,
    paddingRight: 20
  }
});



// WEBPACK FOOTER //
// ./src/components/common/modaltabview/ModalTabView.styles.js